import { SalesTermsMapper } from 'shared/mappers';
import { asUTCDate } from 'shared/utils/DateTime';
import Money from 'shared/utils/Money';
import { AgCollapsibleCard, AgText } from 'src/components/ui';

import { CustomerPortalInvoice } from './useCustomerPortalInvoice';

type Props = { invoice: CustomerPortalInvoice };

export default function InvoiceDetails({ invoice }: Props) {
  return (
    <AgCollapsibleCard title="Invoice Details">
      <div className="flex flex-col md:flex-row gap-4">
        <div className="flex flex-wrap gap-4 flex-1">
          <Field label="Bill To" displayValue={invoice.counterPartyName} />
          <Field label="Payment Terms" displayValue={SalesTermsMapper.getLabel(invoice.paymentTerms)} />
          <Field label="Due Date" displayValue={asUTCDate(invoice.dueDate)?.toFormat('MM/dd/yyyy')} />
          <Field label="Issue Date" displayValue={asUTCDate(invoice.invoiceDate)?.toFormat('MM/dd/yyyy')} />
        </div>
        <div className="flex flex-col gap-2 bg-neutral-2 p-4 rounded-md min-w-48">
          <div className="flex justify-between">
            <AgText size="12" className="uppercase tracking-wider text-neutral-8">
              Total Due
            </AgText>
            <AgText size="20">{Money.toHuman(invoice.totalAmountDue)}</AgText>
          </div>
          <div className="flex justify-between">
            <AgText size="12" className="uppercase tracking-wider text-neutral-8">
              Paid
            </AgText>
            <AgText size="20" className="text-neutral-8">
              {Money.toHuman(invoice.totalPaid)}
            </AgText>
          </div>
          <div className="border-t border-neutral-5" />
          <div className="flex justify-between">
            <AgText size="12" className="uppercase tracking-wider text-neutral-8">
              Remaining
            </AgText>
            <AgText size="20">{Money.toHuman(invoice.amountRemaining)}</AgText>
          </div>
        </div>
      </div>
    </AgCollapsibleCard>
  );
}

const Field = ({ label, displayValue }) => (
  <div className="w-full sm:w-[calc(50%-8px)]">
    <div className="flex flex-col">
      <AgText size="12" className="uppercase tracking-wider text-neutral-8">
        {label}
      </AgText>
      <AgText size="16">{displayValue}</AgText>
    </div>
  </div>
);
